import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'feature-label',
    templateUrl: './feature-label.component.html',
    styleUrls: ['./feature-label.component.css'],
    standalone: false
})
export class FeatureLabelComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
